// Regras de pré-preenchimento e exibição do formulário de confirmação.
// Mantidas como funções puras para facilitar teste e reuso entre os componentes.

export function shouldShowConfirmForm({ isLoading, isAdminOrPartner, confirmation, newAppointmentDateInfo }) {
  if (isLoading || isAdminOrPartner || !confirmation) {
    return false
  }

  // Primeira confirmação: ainda não respondido.
  // Reconfirmação: já respondido, mas uma nova data foi selecionada.
  return !confirmation.answered || !!newAppointmentDateInfo
}

export function buildConfirmationFormState(confirmation = {}) {
  const source = confirmation ?? {}

  return {
    comment: source.comment ?? null,
    confirmed: source.confirmed ?? null,
    attendingToAppointment: source.attending_to_appointment ?? null,
    keysNeedsAuthorization: source.keys_needs_authorization ?? null,
  }
}

// Mapeia o valor booleano para o índice do v-btn-toggle do FormYesOrNo
// (índice 0 = "sim", índice 1 = "não", null = sem seleção).
export function yesNoDecisionIndex(value) {
  if (value === null || value === undefined) {
    return null
  }

  return value ? 0 : 1
}
